import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NavigationStart, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-delete-post-dialog',
  templateUrl: './delete-post-dialog.component.html',
  styleUrls: ['./delete-post-dialog.component.css'],
  standalone: true,
  imports: [MatIconModule, MatButtonModule, CommonModule]
})
export class DeletePostDialogComponent implements OnInit, OnDestroy{

  private navigationSubscription: any;

  constructor(private router: Router,  public dialogRef: MatDialogRef<DeletePostDialogComponent>) { }

  ngOnInit(): void {
     // Intercepter l'événement du bouton retour ou tout changement de navigation
     this.navigationSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // Fermer la fenêtre modale si une navigation arrière est détectée
        this.onCancel();
      }
    });
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  ngOnDestroy(): void {
    // Nettoyer l'abonnement pour éviter les fuites de mémoire
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
  
  
}
